import Vue from 'vue'
import Router from 'vue-router'
import DisplayCompanyName from '@/components/DisplayCompanyName'
import CompanyName from '@/components/CompanyName'
import MainView from '@/components/MainView'
import DetailView from '@/components/DetailView'
import ValueView from '@/components/ValueView'
import ContactView from '@/components/ContactView'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/displayCompanyName',
      name: 'displayCompanyName',
      component: DisplayCompanyName
    },
    {
      path: '/companyName',
      name: 'companyName',
      component: CompanyName
    },
    {
      path: '/detailView',
      name: 'detailView',
      component: DetailView
    },
    {
      path: '/contactView',
      name: 'contactVView',
      component: ContactView
    },
    {
      path: '/valueView/:id',
      name: 'valueView',
      component: ValueView
    },
    {
      path: '/*',
      name: 'mainView',
      component: MainView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js